var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container small", attrs: { id: "signup" } },
    [
      _c("report-background"),
      _vm._v(" "),
      _c("div", { staticClass: "blur-background" }),
      _vm._v(" "),
      _c("div", { staticClass: "page-container" }, [
        _c("div", { staticClass: "main-content-wrapper" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "card-container" },
            [
              _c(_vm.cards[_vm.cardIndex], {
                tag: "component",
                attrs: {
                  emailToVerify: _vm.emailToVerify,
                  checkedPassword: _vm.checkedPassword,
                  userData: _vm.userData,
                },
                on: {
                  verify_account: _vm.verifyAccount,
                  next_index: _vm.nextIndex,
                  updateModal: _vm.updateModal,
                },
              }),
            ],
            1
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "logo" }, [
      _c("img", {
        staticClass: "header-icons",
        attrs: {
          src: "/assets/images/Autobahn_horizontal_combination_mark_white.png",
          alt: "fitness-icon-hero",
          height: "38",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }